module.exports = __webpack_public_path__ + "img/40_69_008_810.a45cb8e8.jpg";